// 从 user-poster-editor/src/editor/components/fetchLoading/views/index.tsx 搬迁
import Lottie from 'lottie-react';
import React from 'react';
import dark from '../lottie/dark.json';
import light from '../lottie/light.json';

// import { useThemeHelper } from '@meitu/saas-editor/es/themeManager';

const THEME_MAP = {
    dark,
    light,
};

type FetchLoadingProps = {
    width?: number;
    animationData?: any;
    style?: React.CSSProperties;
    theme?: string;
};

export const FetchLoading: React.FC<FetchLoadingProps> = React.memo(({ width, animationData, style, theme }) => {
    return (
        <Lottie
            style={{ width: width || 'auto', ...style }}
            animationData={animationData || THEME_MAP[theme || 'light']}
            loop={true}
        />
    );
});
